import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="we-seccion" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="we-titulo-menciones" />
        <div className="we-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="we-mencion" data-testid={`we-mencion-${i}`}>
                <img className="we-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="we-mencion-nombre">{m.nombre}</p>
                  <p className="we-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="we-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`we-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
